import React from 'react';

export function NotFound() {
	return (
		<div>
			<h1>Sorry, can’t find that.</h1>
		</div>
	);
}